import {
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Cascader} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$ma(this.get('sizes'), function($value, $key) {
            return _$cc(Cascader, {
                'size': $value,
                'data': this.get('data')
            });
        }, $this)
    ), 4);
};